import type { useRouter } from 'next/navigation';
import { NavigationClient, type NavigationOptions } from '@azure/msal-browser';

type AppRouterInstance = ReturnType<typeof useRouter>;

/**
 * Used to override redirect handling after loginRedirect and logoutRedirect. We're using
 * next.js for routing, so we need to use the nextjs router.push/replace methods to
 * navigate to other pages.
 */
export class CustomNavigationClient extends NavigationClient {
  router: AppRouterInstance;

  constructor(router: AppRouterInstance) {
    super();
    this.router = router;
  }

  /**
   * Navigates to other pages within the same web application
   * @param url
   * @param options
   */
  async navigateInternal(url: string, options: NavigationOptions) {
    const relativePath = url.replace(window.location.origin, '');
    if (options.noHistory) {
      this.router.replace(relativePath);
    } else {
      this.router.push(relativePath);
    }

    return false;
  }
}
